var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component"},[_c('div',{staticClass:"img-div",style:({ marginTop: _vm.marginTop ? _vm.marginTop + 'px' : '' })},[_c('el-image',{staticClass:"null-img",attrs:{"src":_vm.noIcon}})],1),_c('div',{staticClass:"text-desc"},[_vm._v(_vm._s(_vm.textDesc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }